// @flow

import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';

type Props = {
  resources: Array<BucketResource>,
  isOpen: boolean,
  index?: number,
  onClose: () => void,
};

type State = {
  photoIndex: number,
};

const mapResourcesToUrl = resources =>
  resources
    .map(r => r.url.xhdpi_2x)
    .filter(url => url && url.length)
    .map(url => `${url}?${new Date().toISOString()}`); // Appending date to url to avoid CORS issues

class ResourcesGallery extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      photoIndex: props.index || 0,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.index !== this.props.index) {
      this.setState({
        photoIndex: nextProps.index,
      });
    }
  }

  movePrev = () => {
    const { resources } = this.props;
    this.setState({
      photoIndex: (this.state.photoIndex + resources.length - 1) %
        resources.length,
    });
  };

  moveNext = () => {
    const { resources } = this.props;
    this.setState({
      photoIndex: (this.state.photoIndex + 1) % resources.length,
    });
  };

  render() {
    const { isOpen, resources, onClose } = this.props;
    const { photoIndex } = this.state;

    if (isOpen) {
      const images = mapResourcesToUrl(resources);

      return (
        <Lightbox
          mainSrc={images[photoIndex]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          onMovePrevRequest={this.movePrev}
          onMoveNextRequest={this.moveNext}
          onCloseRequest={onClose}
        />
      );
    }

    return null;
  }
}

export default ResourcesGallery;



// WEBPACK FOOTER //
// ./src/shared/components/ResourcesGallery.js